import { render, staticRenderFns } from "./ProductsVip.vue?vue&type=template&id=45bb063a&scoped=true&"
import script from "./ProductsVip.vue?vue&type=script&lang=ts&"
export * from "./ProductsVip.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsVip.vue?vue&type=style&index=0&id=45bb063a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb063a",
  null
  
)

export default component.exports